// Età in anni compiuti da data di nascita (campi nasc_g/m/a o data_nascita ISO); null se assente.
export const etaAnni = (e) => {
  let a = Number(e?.nasc_a), m = Number(e?.nasc_m), g = Number(e?.nasc_g);
  if (!(a && m && g) && e?.data_nascita) [a, m, g] = String(e.data_nascita).slice(0, 10).split("-").map(Number);
  if (!(a > 1900 && m >= 1 && m <= 12 && g >= 1 && g <= 31)) return null;
  const t = new Date();
  let y = t.getFullYear() - a;
  if (t.getMonth() + 1 < m || (t.getMonth() + 1 === m && t.getDate() < g)) y -= 1;
  return y;
};

export const isMinore = (e) => { const y = etaAnni(e); return y !== null && y < 18; };
